putOptions